// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab
// @license
// Derived from Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE

export function throttle(func, wait) {
	let lastArgs;
	let result;
	let timerId;
	let lastInvokeTime = 0;

	function invokeFunc(time) {
		const args = lastArgs;

		lastArgs = undefined;
		lastInvokeTime = time;
		result = func.apply(null, args);
		return result;
	}

	function leadingEdge(time) {
		// Start the timer for the trailing edge.
		timerId = setTimeout(timerExpired, wait);
		// Invoke the leading edge.
		return invokeFunc(time);
	}

	function remainingWait(time) {
		const timeSinceLastInvoke = time - lastInvokeTime;
		const remaining = wait - timeSinceLastInvoke;

		return remaining;
	}

	function shouldInvoke(time) {
		const timeSinceLastInvoke = time - lastInvokeTime;

		// Either this is the first call, activity has stopped and we're at the
		// trailing edge, the system time has gone backwards and we're treating
		// it as the trailing edge, or we've hit the `maxWait` limit.
		return (timeSinceLastInvoke >= wait)
			|| (timeSinceLastInvoke < 0);
	}

	function timerExpired() {
		const time = performance.now();
		if (shouldInvoke(time)) {
			return trailingEdge(time);
		}
		// Restart the timer.
		timerId = setTimeout(timerExpired, remainingWait(time));
	}

	function trailingEdge(time) {
		timerId = undefined;

		// Only invoke if we have `lastArgs` which means `func` has been
		// debounced at least once.
		if (lastArgs) {
			return invokeFunc(time);
		}
		lastArgs = undefined;
		return result;
	}

	function cancel() {
		if (typeof timerId !== "undefined") {
			clearTimeout(timerId);
		}
		lastArgs = timerId = undefined;
	}

	function flush() {
		return (typeof timerId === "undefined")
			? result
			: trailingEdge(performance.now());
	}

	function debounced() {
		const time = performance.now(),
		isInvoking = shouldInvoke(time);

		lastArgs = arguments;

		if (isInvoking) {
			if (typeof timerId === "undefined") {
				return leadingEdge(time);
			}
		}
		if (typeof timerId === "undefined") {
			timerId = setTimeout(timerExpired, wait);
		}
		return result;
	}

	debounced.cancel = cancel;
	debounced.flush = flush;
	return debounced;
};
